import { EXPLORER_URLS } from './Constants'

const addressType = (network: string, initialType: 'address' | 'tx'): string => {
  if (network === 'PolkadotTestnet' || network === 'Polkadot') {
    if (initialType === 'tx') {
      return 'extrinsic'
    }
  }

  if (network === 'TronTestnet' || network === 'Tron') {
    if (initialType === 'tx') {
      return 'transaction'
    }
  }

  return initialType
}

export const formatExplorerUrl = (network: string, type: 'address' | 'tx', hash: string): string => {
  if ((network === 'TronTestnet' || network === 'Tron') && hash.startsWith('0x')) {
    hash = hash.slice(2)
  }

  return `${EXPLORER_URLS[network]}/${addressType(network, type)}/${hash}`
}
